import contractArbNova from "../chains/arbitrum-nova/artifacts/contracts/ChainRunes.sol/ChainRunes.json";
import contractBase from "../chains/base/artifacts/contracts/ChainRunes.sol/ChainRunes.json";
import contractEthereum from "../chains/ethereum/artifacts/contracts/ChainRunes.sol/ChainRunes.json";
import contractGodwoken from "../chains/godwoken/artifacts/contracts/ChainRunes.sol/ChainRunes.json";
import contractLinea from "../chains/linea/artifacts/contracts/ChainRunes.sol/ChainRunes.json";
import contractOpBnb from "../chains/opbnb/artifacts/contracts/ChainRunes.sol/ChainRunes.json";
import contractPgn from "../chains/pgn/artifacts/contracts/ChainRunes.sol/ChainRunes.json";
import contractPolygonZkEvm from "../chains/polygon-zkevm/artifacts/contracts/ChainRunes.sol/ChainRunes.json";
import contractScroll from "../chains/scroll/artifacts/contracts/ChainRunes.sol/ChainRunes.json";
import contractTaiko from "../chains/taiko/artifacts/contracts/ChainRunes.sol/ChainRunes.json";
import contractZkSync from "../chains/zksync/artifacts-zk/contracts/ChainRunes.sol/ChainRunes.json";
import contractZora from "../chains/zora/artifacts/contracts/ChainRunes.sol/ChainRunes.json";

export const ChainsInfo = {
    useMainnet: false,
    ethereum: {
        abi: contractEthereum.abi,
        testnet: {
            chainId: BigInt(11155111),
            requestParams: {
                chainId: "0xaa36a7",
                rpcUrl: "https://rpc.sepolia.org"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x6E3Aa6C1f156aDB51362a605Fd05FB6704f57379"
        },
        mainnet: {
            chainId: BigInt(1),
            requestParams: {
                chainId: "0x1",
                rpcUrl: "https://1rpc.io/eth"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x7c0154E411943CcA17fc141c4e7555EC30dDD250"
        }
    },
    arbNova: {
        abi: contractArbNova.abi,
        testnet: {
            chainId: BigInt(421614),
            requestParams: {
                chainId: "0x66eee",
                rpcUrl: "https://sepolia-rollup.arbitrum.io/rpc"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x725f835A251B789702f8536AEaE112fdfE006aaA"
        },
        mainnet: {
            chainId: BigInt(42170),
            requestParams: {
                chainId: "0xa4ba",
                rpcUrl: "https://nova.arbitrum.io/rpc"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x67f0CB20E6F325CBd94EEe4a77F119c64C9a1AD5"
        }
    },
    base: {
        abi: contractBase.abi,
        testnet: {
            chainId: BigInt(84531),
            requestParams: {
                chainId: "0x14a33",
                rpcUrl: "https://goerli.base.org"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x725f835A251B789702f8536AEaE112fdfE006aaA"
        },
        mainnet: {
            chainId: BigInt(8453),
            requestParams: {
                chainId: "0x2105",
                rpcUrl: "https://mainnet.base.org"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x1626D76797B48C5C0996E51dD25608888449118A"
        }
    },
    godwoken: {
        abi: contractGodwoken.abi,
        testnet: {
            chainId: BigInt(71401),
            requestParams: {
                chainId: "0x116e9",
                rpcUrl: "https://v1.testnet.godwoken.io/rpc"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x94A3b97FB3Ed85f038b12499665E3AE4A7140307"
        },
        mainnet: {
            chainId: BigInt(71402),
            requestParams: {
                chainId: "0x116ea",
                rpcUrl: "https://v1.mainnet.godwoken.io/rpc"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x05B41D39d0C7175200B6E95744Ed0AF02cE9e373"
        }
    },
    linea: {
        abi: contractLinea.abi,
        testnet: {
            chainId: BigInt(59140),
            requestParams: {
                chainId: "0xe704",
                rpcUrl: "https://rpc.goerli.linea.build/"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x1626D76797B48C5C0996E51dD25608888449118A"
        },
        mainnet: {
            chainId: BigInt(59144),
            requestParams: {
                chainId: "0xe708",
                rpcUrl: "https://rpc.linea.build/"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x725f835A251B789702f8536AEaE112fdfE006aaA"
        }
    },
    opBnb: {
        abi: contractOpBnb.abi,
        testnet: {
            chainId: BigInt(5611),
            requestParams: {
                chainId: "0x15eb",
                rpcUrl: "https://opbnb-testnet-rpc.bnbchain.org/"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x67f0CB20E6F325CBd94EEe4a77F119c64C9a1AD5"
        },
        mainnet: {
            chainId: BigInt(204),
            requestParams: {
                chainId: "0xcc",
                rpcUrl: "https://opbnb-mainnet-rpc.bnbchain.org"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x1626D76797B48C5C0996E51dD25608888449118A"
        }
    },
    pgn: {
        abi: contractPgn.abi,
        testnet: {
            chainId: BigInt(58008),
            requestParams: {
                chainId: "0xe298",
                rpcUrl: "https://sepolia.publicgoods.network"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x67f0CB20E6F325CBd94EEe4a77F119c64C9a1AD5"
        },
        mainnet: {
            chainId: BigInt(424),
            requestParams: {
                chainId: "0x1A8",
                rpcUrl: "https://rpc.publicgoods.network"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: ""
        }
    },
    polygon: {
        //abi: contractPolygonZkEvm.abi,
        testnet: {
            chainId: BigInt(80001),
            requestParams: {
                chainId: "0x13881",
                rpcUrl: "https://polygon-mumbai-bor.publicnode.com"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: ""
        },
        mainnet: {
            chainId: BigInt(137),
            requestParams: {
                chainId: "0x89",
                rpcUrl: "https://1rpc.io/matic"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: ""
        }
    },
    polygonZkEvm: {
        abi: contractPolygonZkEvm.abi,
        testnet: {
            chainId: BigInt(1442),
            requestParams: {
                chainId: "0x5a2",
                rpcUrl: "https://rpc.public.zkevm-test.net"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x67f0CB20E6F325CBd94EEe4a77F119c64C9a1AD5"
        },
        mainnet: {
            chainId: BigInt(1101),
            requestParams: {
                chainId: "0x44d",
                rpcUrl: "https://zkevm-rpc.com"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x67f0CB20E6F325CBd94EEe4a77F119c64C9a1AD5"
        }
    },
    scroll: {
        abi: contractScroll.abi,
        testnet: {
            chainId: BigInt(534351),
            requestParams: {
                chainId: "0x8274f",
                rpcUrl: "https://sepolia-rpc.scroll.io"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x7c0154E411943CcA17fc141c4e7555EC30dDD250"
        },
        mainnet: {
            chainId: BigInt(534352),
            requestParams: {
                chainId: "0x82750",
                rpcUrl: "https://rpc.scroll.io"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x725f835A251B789702f8536AEaE112fdfE006aaA"
        }
    },
    taiko: {
        abi: contractTaiko.abi,
        testnet: {
            chainId: BigInt(167007),
            requestParams: {
                chainId: "0x28c5f",
                rpcUrl: "https://rpc.jolnir.taiko.xyz"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x67f0CB20E6F325CBd94EEe4a77F119c64C9a1AD5"
        },
        mainnet: {
            chainId: BigInt(0),
            requestParams: {
                chainId: "",
                rpcUrl: ""
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: ""
        }
    },
    zksync: {
        abi: contractZkSync.abi,
        testnet: {
            chainId: BigInt(280),
            requestParams: {
                chainId: "0x118",
                rpcUrl: "https://testnet.era.zksync.dev"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0xB123D7f16a8C8F0bab00dcbC7F96018853aD2b2c"
        },
        mainnet: {
            chainId: BigInt(324),
            requestParams: {
                chainId: "0x144",
                rpcUrl: "https://mainnet.era.zksync.io"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x1fEC53dcfdaE47CBD0808734981f4472D3F62fB1"
        }
    },
    zora: {
        abi: contractZora.abi,
        testnet: {
            chainId: BigInt(999),
            requestParams: {
                chainId: "0x3E7",
                rpcUrl: "https://testnet.rpc.zora.energy/"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x05B41D39d0C7175200B6E95744Ed0AF02cE9e373"
        },
        mainnet: {
            chainId: BigInt(7777777),
            requestParams: {
                chainId: "0x76adf1",
                rpcUrl: "https://rpc.zora.energy/"
            },
            deployer: "0xB2099547198d602012320B6c1c1e24940633E7F9",

            contract: "0x7c0154E411943CcA17fc141c4e7555EC30dDD250"
        }
    }
}